<script>
    import {createEventDispatcher} from "svelte";

    let dispatch = createEventDispatcher();

    export let isPlaying = false;
</script>

<div on:click={() => dispatch("click")}>
    {#if isPlaying}
        <svg class="icon" width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="95" height="95" rx="47.5" fill="#F1F1EE" fill-opacity="0.4"/>
            <path d="M40 32V64" stroke="#1A1A17" stroke-width="3"/>
            <path d="M56 32V64" stroke="#1A1A17" stroke-width="3"/>
            <rect x="0.5" y="0.5" width="95" height="95" rx="47.5" stroke="#1A1A17"/>
        </svg>


    {:else}
        <svg class="icon" width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="95" height="95" rx="47.5" fill="#F1F1EE" fill-opacity="0.4"/>
            <rect x="0.5" y="0.5" width="95" height="95" rx="47.5" stroke="#1A1A17"/>
            <path d="M71 48.5L37.25 67.9856L37.25 29.0144L71 48.5Z" fill="#191917"/>
        </svg>

    {/if}

</div>

